import { type GroupItemNFT, type SocialGroupTypeOverride } from '@app/client/common/structs/groups/groups';

interface NftItemIsActiveCriteria {
    itemId: SocialGroupTypeOverride['id'];
    podImageId?: SocialGroupTypeOverride['header_yat_page_item_id'];
}

export function nftItemIsActive({ itemId, podImageId }: NftItemIsActiveCriteria) {
    return Boolean(podImageId && podImageId === itemId);
}

export function nftItemMatchesSearch({ collection_name, name }: GroupItemNFT, searchValue: string) {
    // TODO: Do we actually care about `collection_name`?
    // Are there other properties we should search across?
    const matchedCollectionName = collection_name?.includes(searchValue);
    const matchedName = name?.includes(searchValue);

    return matchedCollectionName || matchedName;
}
